
<template>
    <template v-if="viewData.config.settings?.target">
        <template v-if="portalStore.company === undefined"></template>
        <template v-else-if="viewData.config.settings?.target?.workflowcard_id || viewData.workflowcard_id">
            <div class="row tabrow" v-if="viewData.workflowcard_id">
                <div class="col-sm-8 tabcolumn">
                    <ul class="block-grid tabs">
                        <li v-for="tab in tabs('maincolumn')" :class="{ active: tab_active(tab.property.type, tab.property.id) }" @click.prevent="handleTab(tab.property.type, tab.property.id)">
                            <span class="title">{{ trans(overrule("tab", tab.label)) }}</span>
                        </li>
                    </ul>
                    <tab-overview :tabs="tabs('maincolumn')" :hide_heading="true" />
                </div>
                <div class="col-sm-4 sidecolumn">
                    <tab-overview :tabs="tabs('sidecolumn')" :always_open="true" />
                </div>
            </div>
            <div v-else class="error">
                {{ trans("Het lijkt erop dat het betreffende item niet (meer) te bereiken is.")}}<br>
                {{ trans("Mocht dit probleem aanhouden, neem dan contact op met de beheerder.") }}
            </div>

        </template>
        <template v-else-if="viewData.workflowphase_id">

            <workflowphase-list
                :workflowboard_id="viewData.workflowboard_id"
                :workflowphase_id="viewData.workflowphase_id"
                :related_filter_json="viewData.extra_filters"
                :key="viewData.overview_ticker"
            ></workflowphase-list>

        </template>
        <template v-else>

            <workflowphase-overview
                v-if="viewData.workflowboard_id"
                :layout="viewData.layout"
                :workflowboard_id="viewData.workflowboard_id"
                :workflowphase_id="viewData.workflowphase_id"
                :related_filter_json="viewData.extra_filters"
                :key="viewData.overview_ticker"
            ></workflowphase-overview>

        </template>
    </template>
    <template v-else>
        {{ route.meta.module }} {{ route.meta.action }}<br>
        {{ viewData.type }}<br>
    </template>
</template>

<script>
import { defineComponent, inject } from "vue";
import { useRoute } from "vue-router";

import tabOverview from "view/dashboard/includes/tab-overview";

import { company, portalStore } from "store/portal";
import { workflowproperties, workflowpropertiesbyfieldgroup } from "store/workflow";

import Icon from "components/icon";
import trans from "helpers/_translation";

import workflowphaseList from "view/dashboard/includes/workflowphase-list";
import workflowphaseOverview from "view/dashboard/includes/workflowphase-overview";

export default defineComponent({
    name: "part",
    components: {
        Icon,

        tabOverview,

        workflowphaseList,
        workflowphaseOverview
    },
    setup() {
        const route = useRoute();
        const viewData = inject("viewData");

        const handleTab = inject("handleTab");
        const tabs = inject("tabs");
        const tab_editable = inject("tab_editable");
        const tab_active = inject("tab_active");

        const overrule = inject("overrule");

        return {
            trans,
            route,

            company,
            portalStore,

            viewData,
            workflowproperties,
            workflowpropertiesbyfieldgroup,

            tabs,
            tab_active,
            tab_editable,
            handleTab,

            overrule
        }
    }
});
</script>
<script setup>
</script>